import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "masthead" }


import TitleBar, { TitleBarProps } from '@shell/components/Resource/Detail/TitleBar/index.vue';
import Metadata, { MetadataProps } from '@shell/components/Resource/Detail/Metadata/index.vue';
import Cards from '@shell/components/Resource/Detail/Cards.vue';

export interface MastheadProps {
  titleBarProps: TitleBarProps;
  metadataProps: MetadataProps;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    titleBarProps: {},
    metadataProps: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleBar, _normalizeProps(_guardReactiveProps(props.titleBarProps)), _createSlots({ _: 2 }, [
      (_ctx.$slots['additional-actions'])
        ? {
            name: "additional-actions",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "additional-actions")
            ]),
            key: "0"
          }
        : undefined
    ]), 1040),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createVNode(Metadata, _normalizeProps(_guardReactiveProps(props.metadataProps)), null, 16),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(Cards, {
      class: "mb-20",
      resource: props.titleBarProps.resource
    }, null, 8, ["resource"])
  ]))
}
}

})